<template>
	<div>
    <section class="order-main">
        <div class="content">
            <div class="order-filter mgtop25">
                <div class="filter-form">
                    <div class="filter-box">
                        <div class="filter-item">
                            <label class="item-title">订单号：</label>
                            <input class="item-input" type="text" v-model="OrderNO" />
                            <!-- <input class="item-input" type="text"> -->
                        </div>
                        <div class="filter-item">
                            <label class="item-title">日期选择：</label>
                            <select class="item-input" v-model="DateType">
	                           	<option value="1">预订时间</option>
	                           	<option value="2">入住时间</option>
															<option value="3">离店时间</option>
	                        </select>
                        </div>                        
                    </div>
                    <div class="filter-box">
                        <div class="filter-item">
                            <label class="item-title">客人名称：</label>
                            <input class="item-input" type="text" v-model="CustName" />
                            <!-- <input class="item-input" type="text"> -->
                        </div>                        
                        <div class="filter-item"> 
                            <label class="item-title ">起止时间：</label>
                            <div class="date-input">
                                <div class="date-box "  @click="calendar.show=true">
                                	<input class="item-date calendarBegin " type="text" v-model="DateFrom" />
                                </div>
                 				<calendar v-if="calendar.show" :zero="calendar.zero" :lunar="calendar.lunar" :value="calendar.value" :begin="calendar.begin"  @select="calendar.select"></calendar>
                                <div class="date-box" @click="calendar2.show=true">
                                	<input class="item-date calendarEnd" type="text" id="dateEnd22" v-model="DateTo" />
                                </div>
                             	<calendar style="margin-left:133px"  v-if="calendar2.show" :zero="calendar2.zero" :lunar="calendar2.lunar" :value="calendar2.value" :begin="calendar2.begin"  @select="calendar2.select"></calendar>

                            </div>
                        </div>
                    </div>
                    <div class="filter-box">
                        <div class="filter-item">
                            <label class="item-title">酒店确认号：</label>
                            <input class="item-input" type="text" v-model="ConfirmNO"  />
                            <!-- <input class="item-input" type="text"> -->
                        </div>
                        <div class="filter-item">
                            <label class="item-title">酒店名称：</label>
                            <input class="item-input" type="text" v-model="HotelName" />
                            <!-- <input class="item-input" type="text"> -->
                        </div>                       
                    </div>
                </div>
                <div class="clear"></div>
                <div class="search-btn" @click="postData(1)">查询</div>
                <div class="search-btn box" style="color: #333333;float: right; background: #fbfbfb; border:1px solid #e6e6e6; margin-right: 815px; margin-top: -33px;" @click="exportOrder()">导出</div>
            </div>
        </div>
              
    </section>
    <section class="order-content">
        <div class="content">
            <table class="order-table" cellspacing="0">
                <thead>
                    <tr style="font-weight: 600;">
                        <td width="15%">订单号</td>
                        <td width="20%">酒店名称</td>
                        <td width="8%">房型名称</td>
                        <td width="8%">客人名称</td>
                        <td width="8%">入住日期<br>离店日期</td>
                        <td width="5%">房间数</td>
												<td width="8%">金额</td>
												<td width="8%">附加费</td>
                        <td width="6%">申请时间</td>
                        <td width="5%">操作</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in list">
						<td>{{item.PurchaseOrderId}}</td>
	                	<td>{{item.HotelName}}</td>
	                	<td>{{item.RoomName}}</td>
	                	<td>{{item.GuestName}}</td>
	                	<td>{{item.CheckIn}}<br>{{item.CheckOut}}</td>
	                	<td>{{item.RoomNum}}</td>
						<td>{{item.BaseAmount}}</td>
						<td>{{item.SurchargePrice}}</td>
	                	<td>{{item.CreatTime}}</td>
	                    <td>
	                    	<a class="check" @click="paymentView(item)" v-if="item.Paymented">
	                    		<span class="pay-check"></span>查看
	                    	</a>
	                    	<span v-if="!item.Paymented">暂无</span>

	                    </td>
                    </tr>
                    <tr v-if="!list||list.length<=0">
                    	<td colspan="10">没有相关数据</td>
                    </tr>
                </tbody>
            </table>
            <div class="paging-list" v-if="list&&list.length>0">
				<paginate
				    :page-count="pageCount"
				    :page-range="2"
				    :margin-pages="1"
				    :force-page="page"
				    :click-handler="postData"
				    :prev-text="'<<上一页'"
				    :next-text="'下一页>>'"
				    :container-class="'pagination'"
				    :page-class="'page-item'">
				</paginate>
	            <span class="total-page">共{{pageCount}}页</span>
	            <div class="clear"></div>
	        </div>
	   		<section class="section-footer">
		        <div class="">
		            <p>预订及售后电话（酒店专用）：020-2214 6801  国内产品：0755-82365588-1  香港产品：0755-82365588-2  海外产品：0755-82365588-3  澳门产品：0756-8281308</p>
		            <p>Copyright2013-2017,cnbooking.net.All rights reserved. <a href="https://beian.miit.gov.cn/">粤ICP备09018804号</a> <a href="https://beian.mps.gov.cn/#/query/webSearch"> <img style="vertical-align: sub;" src="./../../assets/images/element.png" alt=""> 粤公网安备 44030302000401号</a></p>
		        </div>
		    </section>
		    <PaymentView :vdata="paymentViewData" ></PaymentView>

			<form :action='Api.getExportEBOrders' method='post'  id= 'formSubmit' target="_blank" >  
				<input type='hidden' name='page' :value="page" />  
				<input type='hidden' name='DateType' :value="DateType" />  
				<input type='hidden' name='DateFrom' :value="DateFrom.split('-').join('/')" />  
				<input type='hidden' name='DateTo' :value="DateTo.split('-').join('/')" />  
				<input type='hidden' name='OrderNO' :value="OrderNO" />  
				<input type='hidden' name='CustName' :value="CustName" />  
				<input type='hidden' name='ConfirmNO' :value="ConfirmNO" />  
				<input type='hidden' name='Oper'  />  
				<input type='hidden' name='OrderStatus'  />  
				<input type='hidden' name='OrderType'  />  
				<input type='hidden' name='HotelName' :value="HotelName" />  
				<!-- <button type='submit' id='exportOrderbtn'>提交</button>   -->
			</form> 

        </div>
    </section>		
	</div>
</template>
<script>
import Paginate from 'vuejs-paginate'
import PaymentView from './paymentView.vue'
import Calendar from './../../common/calendar/calendar.vue'//日期选择器
	export default{
		name:'payment',
		components:{
			Paginate,
			PaymentView,
			Calendar
		},
		data(){
			return{
		  		hotelName:this.dao.get('HotelName'),
		    	list:[],
		    	type:'Untreated',
		    	page:0,
		    	pageSize:10,
		    	pageCount:1,
		    	total:0,
		    	totalNew:0,
		    	totalToday:0,
		    	paymentViewData:{},
		    	OrderNO:'',
		    	DateType:1,
		    	CustName:'',
		    	DateFrom:this.getDate(-30),
		    	DateTo:this.getDate(0),
		    	ConfirmNO:'',
		    	HotelName:'',
				calendar:{
		            display:"",
		            show:false,
		            zero:true,
		            value:this.getDate(-30).split('-'),
		            lunar:false, //显示农历
		            select:(value)=>{
		            	
		                if(!value){
		                    this.calendar.show=false;
		                    return;
		                }
		                this.DateFrom=value.join('-');
		               
		                this.calendar.value=value;
		                this.calendar2.begin=value;
					
						this.calendar2.value=value;
		                this.DateTo='';
					
		               
		              
		                this.calendar2.show=true;

		                this.calendar.show=false;
		                var end=document.getElementById('dateEnd22');
		            	end.focus();
		            }
		        },
		        calendar2:{
		            display:"",
		            show:false,
		            zero:true,
		            // begin:'', //默认日期
		            value:this.getDate(0).split('-'),
		            lunar:false, //显示农历
		            select:(value)=>{
		            	
		                if(!value){
		                    this.calendar2.show=false;
		                    return;
		                }
		                this.DateTo=value.join('-');
		               
		                this.calendar2.value=value;
		                this.calendar2.show=false;
		                // this.calendar.display=value.join("-");
		            }
		        },


			}
		},
		mounted() {
			this.postData(1)
		},
		methods:{
			getDefaultDate(count){
				var date = new Date();
	            date.setDate(date.getDate() + count); //获取count天后的日期 
	            var year = date.getFullYear();
	            var month = date.getMonth() + 1;
	            var day = date.getDate();
	       
	            var time = year + '-' + month + '-' + day;
	            return time;

			},
			//初始化数据，page为页码
			initData(page){
				var that=this;
				that.page=page-1;
		        var params={
		          type: that.type,
		          page: page,
		          pageSize: that.pageSize,
		        }
		        that.getRequest({
		            url: that.Api.getOrderList,
		            params: params
		        }).then(res => {
		        	that.list=res.Result;
		        	if(that.type=='Untreated'){
						that.total=res.Total;
		        	}else if(that.type=='New'){
						that.totalNew=res.Total;
		        	}else{
		        		that.totalToday=res.Total;
		        	}
		        	that.pageCount=Math.ceil(res.Total/10);
		        });
			},
			//初始化数据，page为页码
			postData(page){
				var that=this;
				that.page=page-1;
		        var params={
		          page: page,
		          DateType: that.DateType,
		          DateFrom: that.DateFrom.split('-').join('/'),
		          DateTo: that.DateTo.split('-').join('/'),
		          OrderNO: that.OrderNO,
		          CustName: that.CustName,
		          ConfirmNO: that.ConfirmNO,
		          Oper: '',
		          OrderStatus: '',
		          OrderType: '',
		          HotelName: that.HotelName,
		        }
		        that.postRequest({
		            url: that.Api.getWaterList,
		            params: params
		        }).then(res => {
		        	that.list=res.Result;
		        	if(that.type=='Untreated'){
						that.total=res.Total;
		        	}else if(that.type=='New'){
						that.totalNew=res.Total;
		        	}else{
		        		that.totalToday=res.Total;
		        	}
		        	that.pageCount=Math.ceil(res.Total/10);
		        });
			},
			//初始化数据，page为页码
			exportOrder(){
				var that=this;
				// var btn=document.getElementById('formSubmit');
				// btn.submit();
				// return;

				// var that=this;
				
				var page=this.page+1;
		        var params={
		          page: page,
		          DateType: that.DateType,
		          DateFrom: that.DateFrom.split('-').join('/'),
		          DateTo: that.DateTo.split('-').join('/'),
		          OrderNO: that.OrderNO,
		          CustName: that.CustName,
		          ConfirmNO: that.ConfirmNO,
		          Oper: '',
		          OrderStatus: '',
		          OrderType: '',
		          HotelName: that.HotelName,
		        }
		        that.postRequest({
		            url: that.Api.getExportEBOrders,
		            params: params
		        }).then(res => {
		        
		        	this.downloadFile(res)

		     
		        });
			},
		    downloadFile( content){

			 // 创建隐藏的可下载链接
			    var eleLink = document.createElement('a');
			    var url=content.Result;
			    if(!url)return;

			    // eleLink.download =this.DateFrom+this.DateTo+'付款水单.csv';
			    eleLink.download =this.Api.getExportEBOrdersUrl+url;

			    // eleLink.target ='_blank';
			    eleLink.style.display = 'none';
			    // 字符内容转变成blob地址
			    // var blob = new Blob(["\uFEFF"+content],{ type: "data:text/csv;charset=utf-8" });
			    // var blob = new Blob(["\uFEFF"+content],{ 'type':'application\/octet-stream' });
			    // eleLink.href = URL.createObjectURL(blob);
			    eleLink.href = this.Api.getExportEBOrdersUrl+url;


			    console.log(eleLink.href)
			    
			    // 触发点击
			    document.body.appendChild(eleLink);
			    eleLink.click();
			    // 然后移除
			    document.body.removeChild(eleLink);
			},
			paymentView(item){
				this.paymentViewData=item;
				this.$nextTick(function () {
					this.$set(item,'isShow',item.isShow?false:true);
				});
			},
		}
	}
</script>








// WEBPACK FOOTER //
// src/components/payment/payments.vue